module.exports = "<div class=\"operator-group-popup\">\r\n    <create-edit-popup options=\"options\"></create-edit-popup>\r\n</div>"